// All API urls are used in the project
export const API_CLOUDFUNCTIONS = process.env.NEXT_PUBLIC_API_URL
export const API_STRAPI_CMS = process.env.NEXT_PUBLIC_STRAPI_CMS_URL

export const API_INDUSTRIES = process.env.NEXT_PUBLIC_MONEYMADE_INDUSTRIES_URL
export const API_ONE_DATA = process.env.NEXT_PUBLIC_ONE_DATA_API

export const THUMBNAILS_URL = process.env.NEXT_PUBLIC_API_THUMBNAILS_URL
